import { normalizeImageKey, uniqueNonEmptyUrls } from './numberUtils';

export const getResultLotNumber = (result = {}, item = null) => {
  const candidates = [
    result?.['lot#'],
    result?.lot_number,
    item?.['lot#'],
    Array.isArray(result?.items) ? result.items[0]?.['lot#'] : null,
  ];
  for (const candidate of candidates) {
    if (candidate === null || candidate === undefined) continue;
    const normalized = String(candidate).trim();
    if (normalized) return normalized;
  }
  return '';
};

export const getResultImageUrls = (result = {}, item = null) => {
  const resultImageUrls = Array.isArray(result?.image_urls)
    ? result.image_urls
    : typeof result?.image_urls === 'string' && result.image_urls.trim()
      ? [result.image_urls]
      : [];
  const singleResultImageUrl =
    typeof result?.image_url === 'string' && result.image_url.trim() ? [result.image_url] : [];
  const itemImageUrls = Array.isArray(item?.image_urls)
    ? item.image_urls
    : typeof item?.image_urls === 'string' && item.image_urls.trim()
      ? [item.image_urls]
      : [];
  const singleItemImageUrl =
    typeof item?.image_url === 'string' && item.image_url.trim() ? [item.image_url] : [];
  const mergedUrls = uniqueNonEmptyUrls([
    ...resultImageUrls,
    ...singleResultImageUrl,
    ...itemImageUrls,
    ...singleItemImageUrl,
  ]);
  const dedupedByImageKey = [];
  const seenImageKeys = new Set();
  mergedUrls.forEach((url) => {
    const imageKey = normalizeImageKey(url) || String(url || '').trim().toLowerCase();
    if (!imageKey || seenImageKeys.has(imageKey)) return;
    seenImageKeys.add(imageKey);
    dedupedByImageKey.push(url);
  });
  return dedupedByImageKey;
};

export const getDisabledImageKeySet = (result = {}) => {
  const disabled = new Set();
  const disabledKeys = Array.isArray(result?.disabled_image_keys) ? result.disabled_image_keys : [];
  const disabledUrls = Array.isArray(result?.disabled_image_urls) ? result.disabled_image_urls : [];
  [...disabledKeys, ...disabledUrls].forEach((entry) => {
    const normalized = normalizeImageKey(entry);
    if (normalized) disabled.add(normalized);
  });
  return disabled;
};

export const getLotActionKey = (runId, lotNumber) => {
  const runPart = String(runId || '').trim() || 'no-run';
  const lotPart = String(lotNumber || '').trim() || 'no-lot';
  return `${runPart}::${lotPart}`;
};

export const getImageActionKey = (runId, lotNumber, imageUrl) => {
  const lotKey = getLotActionKey(runId, lotNumber);
  const imageKey = normalizeImageKey(imageUrl) || String(imageUrl || '').trim() || 'no-image';
  return `${lotKey}::${imageKey}`;
};

export const getReviewNoteDraftKey = ({
  runId,
  lotNumber,
  resultIndex,
  itemIndex,
  historyIndex,
}) => {
  const runPart = String(runId || '').trim() || 'no-run';
  const lotPart = String(lotNumber || '').trim() || 'no-lot';
  const resultPart = Number.isFinite(Number(resultIndex)) ? String(Number(resultIndex)) : 'no-result';
  const itemPart = Number.isFinite(Number(itemIndex)) ? String(Number(itemIndex)) : 'no-item';
  const histPart =
    historyIndex != null && Number.isFinite(Number(historyIndex)) ? `::hist-${Number(historyIndex)}` : '';
  return `${runPart}::${lotPart}::${resultPart}::${itemPart}${histPart}`;
};
